export const String = {
  PleaseWait: "Please Wait...",
  NoDataFound: "No Data Found.",
  CountryCode: "+255",
};
export const Error = {
  NET_ERR: "Please check your internet connection and try again!",
};
export const SidebarTitle = {
  Dashboard: "Dashboard",
  Master: "Master",
  Vendor: "Vendor Categories",
  Age: "Age Groups",
  Class: "Classes & Subjects",
  Academic: "Academic Years",
  Activity: "Activity Configurations",
  Schools: "Schools",
  Teachers: "Teachers",
  Students: "Students",
  Vendors: "Vendors",
  AboutUs: "About us",
  Privacy: "Privacy Policy",
  Terms: "Terms & Conditions",
  AppSettings: "App Settings",
};
export const Authentication = {
  Login: "Please sign in to your admin account!",
  ForgetPassword: "Forgot password?",
  ForgetText:
    " Please enter your registered email address to receive an OTP for resetting your password.",
  Verify: "Verify your account",
  VerifyText: "We’ve sent an OTP to admin@ulearn.com",
  VText: "Please enter it below to reset the password.",
  ResendOtp: "Resend OTP in",
  GoBack: "Go back to",
  CreatePassword: "Create new password",
  CreateText: "Please set a new password for your account.",
  CreatePasswordButton: "Set password & Sign in",
  SignIn: "Sign in",
  Submit: "Submit",
};
export const cmsString = {
  aboutUsTitle: "Add / Edit About us",
  termsTitle: "Add / Edit Terms and conditions",
  privacyTitle: "Add / Edit Privacy policy",
  save: "Save details",
};
export const VendorCategory = {
  VendorCategoryTitle: "Vendor Categories",
  VendorCategoryTitle1: "All Vendor Categories",
  AddCategory: "Add category",
  Search: "Search by keyword",
  SerialNo: "Sr No",
  Category: "Category",
  SubCount: "Sub Category Count",
  Action: "Actions",
  ViewDetails: "View details",
  SubCategory: "Sub Category",
  EditCategory: "Edit Category",
  DeleteCategory: "Delete Category",
  Repeater: "+ Add Sub Category",
};
export const AgeGroups = {
  AgeGroupTitle: "Age Groups",
  AgeGroupTitle1: "All Age Groups",
  Search: "Search by keyword",
  AddAgeGroup: "Add Age Groups",
  EditAge: "Edit Age Group",
  SerialNo: "Sr No",
  AgeGroup: "Age Group",
  ActivityCount: "Activities Count",
  ViewDetails: "View Details",
  EditAgeGroup: "Edit Age",
  DeleteAgeGroup: "Delete Age",
  FromAge: "From",
  ToAge: "To",
  SelectActivities: "Select Activities",
  Submit: "Submit",
  OptionGeneralComment: "Health",
  OptionSleep: "Sleep Check",
  OptionMedication: "Medication",
  OptionDisposition: "Disposition",
  OptionBathroom: "Bathroom",
  OptionBottle: "Bottle",
  OPtionMeal: "Meal",
  OptionNappy: "Nappy",
  OptionPlay: "Play",
  Edit: "Edit Age Group",
  Delete: "Delete Age Group",
};
export const ClassSubject = {
  ClassTitle: "Classes & Subjects",
  Search: "Search",
  AddButton: "Add Class & Subject",
  ClassTitle1: "All Classes & Subjects",
  TableSerialNo: "Sr No",
  TableClass: "Class",
  TableCount: "Subject Count",
  ViewDetails: "View Details",
  Class: "Class",
  Subject: "Subject",
  Repeater: "+ Add Subjects",
  Submit: "Submit",
  EditClass: "Edit Class & Subject",
  Delete: "Delete Class & Subject",
  EditButton: "Edit Class & Subject",
  NotFound: "No Class and Subject Found.",
};
export const ActivityConfig = {
  Title: "Activity Configurations",
  Title1: "All Activity Configurations",
  Search: "Search",
  AddButton: "Assign Activity",
  EditButton: "Edit Assign Activity",
  TableSerialNo: "Sr No",
  TableActivity: "Activities",
  TableCount: "Age Group Count",
  ViewDetails: "View Details",
  Edit: "Edit Activity",
  Delete: "Delete Activity",
  SelectAge: "Select Age Group",
  SelectActivity: "Select Activities",
  Submit: "Submit",
  ActivateDeactivate: "Activate / Deactivate",
  active: "Active",
  deactivate: "Deactivate",
};
export const SchoolString = {
  Title: "Schools",
  Title1: "All Schools",
  TitleAdd: "Add School",
  TitleEdit: "Edit School",
  Search: "Search",
  AddButton: "Add School",
  EditButton: "Edit Assign Activity",
  TableSerialNo: "Sr No",
  TableActivity: "Activities",
  TableCount: "Age Group Count",
  ViewDetails: "View Details",
  Edit: "Edit Activity",
  Delete: "Delete Activity",
  SelectAge: "Select Age Group",
  SelectActivity: "Select Activities",
  Submit: "Submit",
  Button: "Activate / Deactivate",
  search: "Search",
  filterByClass: "Filter by class",
  srNo: "Sr No",
  schoolName: "School Name",
  adminName: "Admin Name",
  email: "Email",
  teacherCount: "Teacher count",
  schoolCount: "School count",
  viewDetails: "View Details",
  activateDeactivate: "School Name",
  noData: "No Data Found",
  edit: "Edit school",
  editAcademicYear: "Change Academic Year Status",
  delete: "Delete school",
  schoolPhoneNumber: "School Phone number",
  schoolAdminName: "School Admin Name",
  schoolAdminEmail: "School Admin Email",
  selectClass: "Select Class",
  selectAcademicYear: "Select Academic Year",
  selectedAcademicYear: "Selected Academic Year",
  address: "Address",
  city: "City/Town",
  state: "State",
  postalCode: "Postal Code",
  country: "Country",
  studentCount: "Students Count",
  teachersCount: "Teachers Count",
  adminInfo: "Admin Info",
  schoolDetails: "School details",
  uploadPhoto: "Upload image",
};

export const teacherString = {
  searchByKeyword: "Search By Keyword",
  filterBySchool: "Filter By School",
  filterByClass: "Filter By Class",
  filterBySubject: "Filter By Subjects",
  titleTeacher: "Teachers",
  teacherName: "Teacher Name",
  phoneNumber: "Phone Number",
  dateOfJoin: "Date of Joining",
  viewDetails: "View Details",
  teacherProfile: "Teacher Profile",
  joiningDate: "Joining Date",
  experience: "Experience",
  qualification: "Qualification",
  associatedSchool: "Associated School",
  class: "Class",
  subjects: "Subjects",
  noData: "No Data Found",
  division: "Division",
};
export const studentString = {
  titleStudent: "Students",
  searchByKeyword: "Search By Keyword",
  filterBySchool: "Filter By School",
  filterByClass: "Filter By Class",
  filterBySubject: "Filter By Subjects",
  viewDetails: "View Details",
  studentName: "Student Name",
  class: "Class",
  school: "School",
  dateOfBirth: "Date of Birth",
  platformDate: "Platform Joining Date",
  ageGroup: "Age Group",
  schoolInfo: "School Info",
  parentsInfo2: "Guardian Info",
  parentsInfo1: "Parents Info",
  years: "years",
  noData: "No Data Found",
  studentDetails: "Students details",
  classDiv: "Class Info",
};
export const vendorString = {
  Title: "Vendors",
  BusinessName: "Business Name",
  PhoneNumber: "Phone Number",
  VendorsDetails: "Vendors Details",
  AddButton: "Add Vendor",
  Category: "Category",
  Leads: "Leads",
  Viewers: "Viewers",
  Filterbykeyword: "Filter by keyword",
  Filterbycategory: "Filter by category",
  FilterbySubCategory: "Filter by SubCategory",
  edit: "Edit vendor",
  delete: "Delete vendor",
  AddVendor: "Add Vendor",
  Submit: "Submit",
  uploadPhoto: "upload Photo",
  ManageProfile: "Manage profile",
  editVendor: "Edit Vendor",
  BannerImage: "Banner Image",
  ProfileImage: "Profile Image",
  BasicDetails: "Basic details",
  VendorName: "Vendor name",
  Email: "Email",
  Address: "Address",
  SelectCategory: "Select category",
  SubCategory: "Sub category",
  Cancel: "Cancel",
  SaveChanges: "Save changes",
  VendorProfile: "Vendor Profile",
  leads: "Total leads",
  views: "Total views",
  totalServices: "Total Services",
  joiningDate: "Joining Date",
  view: "View Details",
  BuildingNumber: "Building Number",
};

export const DashboardString = {
  dashboard: "Dashboard",
  totalStudent: "Total students",
  totalTeacher: "Total teachers",
  totalSchool: "Total Schools",
  totalVendor: "Total Vendors",
  EnrolledStudents: "Student's Enrolled",
  RegisteredSchool: "Registered Schools",
  RegisteredVendor: "Registered Vendors",
  SchoolwiseStudent: "School's Student",
  ClasswiseStudent: "Number of Students in Class",
};
export const academicString = {
  Title: "Academic Years",
  UpdateTitle: "Update Academic Year",
  Title1: "All Academic Years",
  AddButton: "Add Academic Year",
  Status: "Status",
  StartingYear: "Starting Year",
  EndingYear: "Ending Year",
  DeleteAcademicYear: "Delete Academic Year",
  StartingDate: "Starting Date",
  EndingDate: "Ending Date",
};
